export class ColumnFilterTransitionEventModel {
    constructor(public name: string,
                public content: string,
                public filtersApplied: any) {
    }
}
